import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { TWStaticTradingUpCard } from '../TWStaticTradingUpCard/TWStaticTradingUpCard'

export const StaticTradingUpPromoCardRegistration = createRegisterableComponent(
    'tw-trading-up-promo-card',
    () => <TWStaticTradingUpCard />,
)
